var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-4" },
    _vm._l(_vm.count, function (n) {
      return _c("v-skeleton-loader", {
        key: n,
        staticClass: "mb-4",
        attrs: { type: "card" },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }